import React, { useEffect } from 'react'
import { useCart } from 'lib/core/hooks/useCart'
import { Redirect } from 'react-router-dom'
import { Button, EmptyContainer, Spinner } from 'lib/ui/components'
import { MetaData } from 'components/MetaData'
import { useAbandonedCart } from 'hooks/abandonedCart'
import { CartLayout, Section, TableHeader, Container as MainContainer } from 'app/sofia/scenes/Cart/components/Styled'
import { Container } from 'app/sofia/scenes/Cart/components/List/components/Styled'
import { useCartItems } from 'hooks/cart'
import { ListItem } from 'components/Cart/components/ListItem'
import { Totals } from 'app/sofia/scenes/Cart/components/Totals'
import { CheckoutButton } from 'components/Cart/components/Actions/components/Styled'

interface Props {
  match: {
    params: {
      abandonCartId: string
    }
  }
}

export const AbandonedCart = ({ match }: Props) => {
  const { cartId } = useCart()
  const abandonedCartId = match.params.abandonCartId

  const { cart, isFetching, mergeCarts, mergedCarts, mergingCarts, cartRaw } = useAbandonedCart(abandonedCartId, cartId)

  const title = 'Abandoned Cart'

  const items = cart?.data?.items
  const cartItems = useCartItems(items)

  const handleCombineCarts = () => {
    mergeCarts()
  }

  useEffect(() => {
    if (mergedCarts?.mergeAbandonedCart.id) {
      window.location.href = '/cart'
    }
  }, [mergedCarts])

  if (abandonedCartId === cartId || (!items && !isFetching)) {
    return <Redirect to='/cart' />
  }

  return (
    <>
      <MetaData
        title={title}
      />
      <Section>
        <MainContainer>
          <h1>{title}</h1>

          {isFetching ? (
            <EmptyContainer>
              <Spinner />
            </EmptyContainer>
          ) : (
            <CartLayout>
              <div className='cart-main'>
                <Container>
                  <TableHeader>Products</TableHeader>
                  <ul>
                    {cartItems?.map(cartItem => {
                      const SubItem = cartItem?.associatedProduct
                      const [sampleDuration] = cartItem.product.customAttribute?.promotion_days ?? []

                      if (SubItem?.id) {
                        return (
                          <>
                            <ListItem
                              isSampleSupply
                              key={cartItem.id}
                              cartItem={cartItem}
                              canRemove={false}
                            />
                            <ListItem
                              key={SubItem?.id}
                              cartItem={SubItem}
                              sampleDuration={sampleDuration}
                              isChild
                              canRemove={false}
                            />
                          </>
                        )
                      }

                      return (
                        <ListItem
                          key={cartItem?.id}
                          cartItem={cartItem}
                          canRemove={false}
                        />
                      )
                    })}
                  </ul>
                </Container>
              </div>
              <div className='cart-aside'>
                <Totals abandonedCart={cart} cartRaw={cartRaw?.getAbandonedCart ? { data: cartRaw.getAbandonedCart, isFetching, isCartException: false, isFailure: false, isSuccess: true } : undefined} />
                <CheckoutButton>
                  <Button onClick={handleCombineCarts} isLoading={mergingCarts}>
                    Combine with my cart
                  </Button>
                </CheckoutButton>
              </div>
            </CartLayout>
          )}
        </MainContainer>
      </Section>
    </>
  )
}
